import React from "react";
import { useLocation } from "react-router-dom";
import { FaChevronLeft } from "react-icons/fa";
import { Button } from "react-bootstrap";

import "./styles.scss";
import ClientLogo from "../../client/assets/claro.png";
import ErrorService from "../../services/errorService.js";
import config from '../../client/config';

function ErrorClientPage() {
  const location = useLocation();
  const errorService = new ErrorService();

  const params = new URLSearchParams(location.search);
  const error = {
    code: location.pathname.split("/").pop(),
    message: params.get("message"),
  };

  const returnUrl = params.get("return_url");

  const handleBackClick = () => {
    window.location.href = returnUrl || "/";
  };

  return (
    <main className="main-content">
      <div className="tbxHandleError">
        <div className="tbxHandleError-container">
          <img className="tbxHandleError-logo" src={ClientLogo} alt={config.title} />
          <div className="tbxHandleError-header">
            <Button
              onClick={handleBackClick}
              className="tbxHandleError-backButton"
            >
              <FaChevronLeft />
            </Button>
            <h3 className="tbxHandleError-title">
              LO SENTIMOS! HUBO UN INCONVENIENTE.
            </h3>
          </div>

          <h5 className="tbxHandleError-subTitle">
            {errorService.getErrorMessage(error.code) || error.message}
          </h5>
          <details
            className="tbxHandleError-details"
            style={{ whiteSpace: "pre-wrap" }}
          >
            <summary className="tbxHandleError-summary">MÁS DETALLES</summary>
            <div className="tbxHandleError-errorText">
              {error.code}
              <br />
              {error.message}
            </div>
          </details>
        </div>
      </div>
    </main>
  );
};

export default ErrorClientPage;
